import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import EditableDropdown from '../EditableDropdown';
import FieldTip from '../ui/FieldTip';

const DEFAULT_FUND_TYPES = [
  { value: 'money_market', label: 'Money Market Fund', is_system: true },
  { value: 'fixed_income', label: 'Fixed Income Fund', is_system: true },
  { value: 'equity', label: 'Equity Fund', is_system: true },
  { value: 'balanced', label: 'Balanced Fund', is_system: true },
];

const MutualFundFields = ({ formData, onFieldChange, config, setConfig }) => {
  const fundTypeOptions = (config?.mutual_fund_types?.length > 0)
    ? config.mutual_fund_types.map(opt => ({ ...opt, is_system: opt.is_system !== undefined ? opt.is_system : true }))
    : DEFAULT_FUND_TYPES;

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="fund_manager" className="portfolio-input-label">Fund Manager</Label>
        <Input
          id="fund_manager"
          data-testid="fund-manager-input"
          placeholder="e.g. Vanguard, BlackRock"
          value={formData.fund_manager}
          onChange={(e) => onFieldChange('fund_manager', e.target.value)}
          className="portfolio-input"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="mutual_fund_type" className="portfolio-input-label">Fund Type</Label>
        <EditableDropdown
          value={formData.mutual_fund_type}
          onValueChange={(value) => onFieldChange('mutual_fund_type', value)}
          options={fundTypeOptions}
          onOptionsUpdate={(newOptions) => setConfig(prev => ({...prev, mutual_fund_types: newOptions}))}
          placeholder="Select fund type"
          type="fund_type"
          className="portfolio-input"
          dataTestId="mutual-fund-type-select"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="risk_rating" className="portfolio-input-label">Risk Profile<FieldTip field="risk_profile" /></Label>
        <Select value={formData.risk_rating} onValueChange={(value) => onFieldChange('risk_rating', value)}>
          <SelectTrigger data-testid="risk-rating-select" className="portfolio-input">
            <SelectValue placeholder="Select risk profile" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Low">Low</SelectItem>
            <SelectItem value="Moderate">Moderate</SelectItem>
            <SelectItem value="High">High</SelectItem>
            <SelectItem value="Very High">Very High</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </>
  );
};

export default MutualFundFields;
